<template>
  <div>
      <template v-if="isIndex">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <div class="PlanBox exportCurInfo">
            <!-- 列表 -->
            <ots-table-group-new
              :tableHeader="tableHeader"
              :tableOption="tableOption"
              :tableData="tableData"
              :pagination="pagination"
              @changeNum="changeSize"
              @changePage="changePage"
            ></ots-table-group-new>
        </div>
      </template>
      <template v-else>
        <router-view />
      </template>
  </div>
</template>

<script>

import { 
  downExportFileFn, 
  getExportListFn,
  getUnreadCountFn,
  updateReadFn 
} from '@/http/modules/exportDownInfo'
import OtsTableGroupNew from '@/package/OtsTableGroupNew/OtsTableGroupNew.vue';

export default {
  components: { OtsTableGroupNew },
  name: 'exportDownInfo',
  data () {
    return {
      tableData: [],
      tableHeader: [
        {
          title: "序号",
          prop: "msgIndex",
          width:"80"
        },
        {
          title: "消息类型",
          prop: "jobType",
          width:"120",
          formatter: (val) => {
            // '1导入消息、2导出消息
            if(val.row.jobType==1){
              return '导入消息';
            }else if(val.row.jobType==2){
              return '导出消息';
            }
          },
        },
        {
          title: "功能名称",
          prop: "menuName",
          formatter: (val) => {
            // jobReview 1 未读，0 已读 
            if(val.row.jobReview==0){
              return '<span class="redDot"></span>'+val.row.menuName;
            } else{
              return val.row.menuName;
            }
          },
        },
        {
          title: "文件名称",
          prop: "fileName",
          type:"buttonTip",
          click: this.downExportFileInfo,
        },
        {
          title: "处理结果",
          prop: "resultStatus",
          formatter: (val) => {
            // 1成功，0失败，-1 未执行 // 
            if(val.row.resultStatus==1){
              return '成功';
            }else if(val.row.resultStatus==0){
              if(val.row.resultRemark==""){
                return '失败';
              }else{
                return val.row.resultRemark;
              }
            }else if(val.row.resultStatus=='-1'){
              return '--';
            }
          },
          type: 'tag_Z',
          tagColor: (scope) => {
            if(scope.row.resultStatus==1){
              return 'col_green';
            }else if(scope.row.resultStatus==0){
              return 'col_red';
            }else if(scope.row.resultStatus=='-1'){
              return 'col_grayQ';
            }
          },
        },
       
        {
          title: "时间",
          prop: "createDate",
        },
       
      ],
      tableOption: {

      },
      pagination: {
        total: 0,
        page: 1,
      },
      exportMsgParams: {
        page: 1,
        size: 10,
      },
      mainTopBtnList:[]
    }
  },
  computed: {
    isIndex () {
      return this.$route.name == 'exportDownInfo'
    }  
  },
  
  created () {
    this.getExportMsgInfo();
    this.getUnReadInfo();
  },
  methods: {
    async getExportMsgInfo() {
      let oExportMsgInfo = await getExportListFn(this.exportMsgParams);
      let oExportMsgDataInfo = oExportMsgInfo.data;
      for(let i=0;i<oExportMsgDataInfo.records.length;i++){
        let oCurItem = oExportMsgDataInfo.records[i];
        oCurItem["msgIndex"] = i+1;
      }

      this.tableData = oExportMsgDataInfo.records;
      // console.log("tablesSSSSSSSSSS" +JSON.stringify(this.tableData));
      this.pagination.total = oExportMsgDataInfo.total;
    },
    async downExportFileInfo(row) {
      if(row.fileName=="--"){
        // 不做处理
      }else{
        const {code, data}  = await downExportFileFn({jobId:row.id});
        if (code == 1) {
          // 标记已读
          let oMarkInfo = await updateReadFn({jobId:row.id});
          // 获取未读的数量
          let oUnreadInfo = await getUnreadCountFn();
          console.log("AAAAAAAAAAAAAAAAAAAAAA"+data);
          this.$store.commit("updateUnReadMsgCount", oUnreadInfo.data);
          // 更新表格数据
          this.getExportMsgInfo();
          window.open(data);
        }
      }
      
    },
    async getUnReadInfo(){
      let oUnreadInfo = await getUnreadCountFn();
      this.$store.commit("updateUnReadMsgCount", oUnreadInfo.data);
    },
    changeSize(num) {
      this.exportMsgParams.size = num;
      this.getExportMsgInfo();
    },
    changePage(p) {
      this.exportMsgParams.page = p;
      this.getExportMsgInfo();
    },
  }
}
</script>
<style lang="less" scoped>
.PlanBox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .mainCon {
    margin-top: 0;
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
    flex: 1;
  }
}

</style>
<style>
.exportCurInfo .tagZ i{
  display: none !important;
}
.exportCurInfo .redDot{
  width: 4px;
  height: 4px;
  background-color: rgb(245 133 133);
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
}
</style>